<template>
  <div class="custom-datepicker" :class="{ 'my-datepicker-disabled' : disabled }">
      <label for=""> {{ label }} </label>
      <date-picker
        v-model="inputVal"
        format="DD.MM.YYYY"
        type="date"
        :lang="$t('lang') == 'Ру' ? ru : $t('lang') == 'Ўз' ? ru : uz"
        @change="$emit('change',text)"
        input-class="my-custom-date "
        :clearable="false"
        :disabled="disabled"
        :disabled-date="disabledDate"
      >
        <template #input>
            <input :disabled="disabled" @keyup="$emit('keyup',text)" @input="Change" :placeholder="placeholder" v-mask="'##.##.####'" type="text" maxlength="10" :value="text" class="my-custom-date">
        </template>
        <template #icon-calendar>
            <span></span>
        </template>
      </date-picker>
      <div class="my-custom-calendar-icon">
          <b-img src="/images/design/calendar.svg" />
      </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import uz from '../elements/calendarlang'
import ru from 'vue2-datepicker/locale/ru'
import { BImg } from 'bootstrap-vue'
export default {
    components : {DatePicker,BImg},
    props : {
        label : {
            type : String,
            default : ''
        },
        placeholder : {
            type : String,
            default : ''
        },
        disabled:{
            type : Boolean,
            default : false
        },
        disabledDate : {},
        value : {}
    },
    data(){
        return{
            // Inputda ko'rinib turgan matn (DD.MM.YYYY). Qo'lda yozilganda ham shu yangilanadi.
            text : '',
            uz,
            ru
        }
    },
    computed: {
        inputVal: {
            get() {
                return this.ToDate(this.text)
            },
            set(val) {
                if (!val) {
                    this.text = ''
                    this.$emit('input', '')
                    return
                }
                this.text = this.Format(val)
                this.$emit('input', this.text)
            }
        }
    },
    methods:{
        Format(date){
            var dd = String(date.getDate()).padStart(2, "0")
            var mm = String(date.getMonth() + 1).padStart(2, "0")
            var yy = date.getFullYear()
            return `${dd}.${mm}.${yy}`
        },
        // "DD.MM.YYYY" -> Date. To'liq va haqiqiy sana bo'lmasa null qaytaradi
        ToDate(value){
            if (value instanceof Date) return isNaN(value.getTime()) ? null : value
            if (typeof value !== 'string') return null
            var parts = value.split('.')
            if (parts.length !== 3 || parts[0].length !== 2 || parts[1].length !== 2 || parts[2].length !== 4) return null
            var dd = Number(parts[0])
            var mm = Number(parts[1])
            var yy = Number(parts[2])
            if (!dd || !mm || !yy) return null
            var date = new Date(yy, mm - 1, dd)
            // 31.02.2026 kabi mavjud bo'lmagan sanalarni rad etamiz
            if (date.getDate() !== dd || date.getMonth() !== mm - 1 || date.getFullYear() !== yy) return null
            return date
        },
        Stringify(value){
            if (value === null || value === undefined || value === '') return ''
            if (value instanceof Date) return isNaN(value.getTime()) ? '' : this.Format(value)
            return String(value)
        },
        // Qo'lda yozilgan sanani ota-komponentga uzatamiz.
        // Ilgari input propga v-model qilingan edi va $emit('input') umuman chaqirilmasdi —
        // shu sababli kiritilgan sana ko'rinib tursa ham v-model bo'sh qolib, validatsiya xato berardi.
        Change(e){
            this.text = e && e.target ? e.target.value : ''
            var next = this.ToDate(this.text) ? this.text : ''
            if (next !== this.Stringify(this.value)) {
                this.$emit('input', next)
            }
        }
    },
    watch:{
        value : {
            immediate : true,
            handler(newValue){
                var incoming = this.Stringify(newValue)
                if (incoming === this.text) return
                // Foydalanuvchi sanani hali yozib tugatmagan bo'lsa, yozganini o'chirmaymiz
                if (incoming === '' && !this.ToDate(this.text)) return
                this.text = incoming
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';
@import '~vue2-datepicker/scss/index.scss';

    .custom-datepicker{
        border-radius: 12px;
        background-color: #F7F7F7;
        position: relative;
        overflow: hidden;
        label{
            width: 100%;
            padding-left: 16px;
            text-transform: uppercase;
            font-size: 12px;
            color: $input-text-color;
        }
        .my-custom-calendar-icon{
            position: absolute;
            top: 15px;
            right: 15px;
        }
        
    }
    .mx-datepicker{
        .mx-input-wrapper{
            overflow: hidden;
            .my-custom-date{
                border: none !important;
                outline: none;
                background-color: #F7F7F7;
                margin-bottom: 8px;
                padding-left: 16px;
                width: fit-content;
                &::placeholder{
                    color: $input-text-placeholder;
                }
            }
        }
    }
    .my-datepicker-disabled{
        input{
            cursor: not-allowed;
        }
    }
    
</style>